import { isHTMLElement } from '../is-html-element';

export function asHTMLElement(o: any): HTMLElement {
	if (isHTMLElement(o)) {
		return o as HTMLElement;
	}
	return null;
}
